module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-taiguo-h5.677c9d47.jpg";